import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import ClientForm from "./ClientForm";
import aclService from "../services/aclService";

const Clientedit = () => {
  const { id } = useParams();
  const [clientData, setClientData] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [selectedACL, setSelectedACL] = useState(
    location.state?.tenant || null
  );
  //   useEffect(() => {
  //     const fetchClientData = async () => {
  //       try {
  //         const data = await aclService.getClient(id);
  //         setClientData(data);
  //         setLoading(false);
  //       } catch (error) {
  //         console.error("Error fetching client data:", error);
  //         setLoading(false);
  //       }
  //     };

  //     fetchClientData();
  //   }, [id]);

  //   if (loading) {
  //     return <div>Loading...</div>;
  //   }

  return !clientData ? (
    <ClientForm mode="edit" clientData={selectedACL} />
  ) : (
    <div>Client not found</div>
  );
};

export default Clientedit;
